export var wrapAudioScheduledSourceNodeStopMethodNegativeParameters = function wrapAudioScheduledSourceNodeStopMethodNegativeParameters(nativeAudioScheduledSourceNode) {
  nativeAudioScheduledSourceNode.stop = function (stop) {
    return function () {
      var when = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      if (when < 0) {
        throw new RangeError("The parameter can't be negative.");
      }
      stop.call(nativeAudioScheduledSourceNode, when);
    };
  }(nativeAudioScheduledSourceNode.stop);
};